import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    ShowButton,
    EditButton,
    TextInput,
    ReferenceField,
    TopToolbar,
    CreateButton,
    FilterButton,
    ExportButton,
} from 'react-admin';

const telephoneFilters = [
    <TextInput label="Id" source="id" name="Id" />,
    <TextInput label="Telephone" source="telephone" name="telephone" />,
    <TextInput label="Company id" source="company" name="company" />,
];

const ListActions = () => {
    return(
        <TopToolbar>
            <CreateButton />
            <FilterButton />
            <ExportButton />
        </TopToolbar>
    );
}

export const AdminTelephoneList = () => {
    return (
        <List
            actions={<ListActions/>}
            filters={ telephoneFilters }>
            <Datagrid bulkActionButtons={false}>
                <TextField source="id"/>
                <TextField source="telephone" />
                <TextField source="description" />
                <ReferenceField
                    source="company"
                    reference="companies"
                    link="edit"
                >
                    <TextField source="name"/>
                </ReferenceField>

                <>
                    <ShowButton/>
                    <EditButton/>
                </>
            </Datagrid>
        </List>
    );
}